@if (user$ | async; as user) {
  <div odxLayout="flex" class="flex-column container">
    <app-country-selection
      [selectedCountry]="selectedCountry || user.country"
      (selectionChange)="onClickSelectCountry($event)"
    ></app-country-selection>
    <app-language-selection
      [selectedLanguage]="selectedLanguage || user.language"
      (selectionChange)="onClickSelectLanguage($event)"
    ></app-language-selection>
    @if ((user$ | async)?.scope !== BusinessScope.MONITORING) {
      <odx-switch
        [checked]="selectedShowZrefPrices ?? user.showZrefPrices"
        (checkedChange)="onToggleZrefPrices()"
        data-testid="toggle.localesMenu.showZrefPrices"
        >{{ zrefPricesLabel }}</odx-switch
      >
    }
    <button odxButton variant="primary" (click)="onSubmit()" i18n="@@global.save" data-testid="btn.localesMenu.submit">
      Speichern
    </button>
  </div>
}
